import { createApi, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { Role } from '@/models/AccountEnums';

export interface AgreedTermsResponse {
  TermId: number;
  Description: string;
  Html: string;
  Type: Role;
  AgreeDate: string; //"2016-10-28T12:44:17.267";
}

export const termsApi = createApi({
  reducerPath: 'termsApi',
  baseQuery: waServicesQuery,
  tagTypes: ['AgreedTerms'],
  endpoints: (builder) => ({
    getAgreedTerms: builder.query<AgreedTermsResponse[], void>({
      queryFn: async (_arg, _queryApi, _unused, baseQuery) => {
        const result = await baseQuery('/api/user/agreedTerms');

        if (result.error) {
          return { error: result.error as FetchBaseQueryError };
        }

        const transformedData = (
          result.data as { Records: AgreedTermsResponse[] }
        ).Records;

        return { data: transformedData };
      },
    }),
  }),
});

export const { useGetAgreedTermsQuery } = termsApi;
